import React from 'react';
import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="app-footer">
      <span>{t('footer.app_name', 'Voice Agent Admin')}</span>
      <span>{t('footer.version', 'v1.0.0')}</span>
    </footer>
  );
}
